/* global window */

import Cookies from 'js-cookie';
import { Route } from 'react-router-dom';

const CheckoutRoute = ({ component: Component, ...rest }) => {
  const redirectToCart = () => {
    window.location.href = '/cart';
    return null;
  };
  return (
    <Route
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
      render={(props) =>
        // eslint-disable-next-line react/jsx-props-no-spreading
        Cookies.get('cartId') ? <Component {...props} /> : redirectToCart()
      }
    />
  );
};

export default CheckoutRoute;
